module.exports = __webpack_public_path__ + "images/FUSA_icons/033-delivery.f2d0022f711f77654f42b78b199d9545.svg";